// 判断是否是ios还是安卓
//点击下载按钮判断
export function appPostMessage(msg) {
	const msgVal = JSON.stringify(msg);
	var u = navigator.userAgent;
	var isiOS = !!u.match(/\Mac OS X/);
	// var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
	var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
	if (isiOS) {
		window.webkit.messageHandlers.FUNTOY.postMessage(msgVal);
	} else if (isAndroid) {
		window.FUNTOY.postMessage(msgVal);
	} else if (u.match(/iPad/i) == 'ipad') {
		window.webkit.messageHandlers.FUNTOY.postMessage(msgVal);
	}
}

// 判断手机安卓还是
export function ua() {
	var u = navigator.userAgent;
	let uaType = '';
	if (!!u.match(/\Mac OS X/) || u.match(/iPad/i) == 'ipad') {
		uaType = 'ios';
	} else if (u.indexOf('Android') > -1 || u.indexOf('Adr') > -1) {
		uaType = 'Android';
	} else {
		uaType = 'pc';
	}
	return uaType;
}
